module.exports = __webpack_public_path__ + "assets/img/talk.6153887d.svg";